var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ConfirmDialog, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useLastSignRequest } from 'app/domains/esigning/hooks/useLastSignRequest';
import { useRemoveEsigningRecipient } from 'app/domains/esigning/hooks/useRemoveEsigningRecipient';
export function RemoveRecipientDialog(props) {
    const { recipient, onClose } = props;
    const { id, name } = recipient;
    const { refetch } = useLastSignRequest();
    const { addToast } = useToast();
    const [removeRecipient, { loading }] = useRemoveEsigningRecipient();
    const handleRemoveRecipient = () => __awaiter(this, void 0, void 0, function* () {
        removeRecipient({
            variables: {
                input: { id },
            },
            onSuccess: () => __awaiter(this, void 0, void 0, function* () {
                yield refetch();
                onClose();
            }),
            onError: () => {
                addToast({
                    title: t({
                        message: 'Could not withdraw eSigning party',
                        comment: 'Withdraw esigning party dialog error',
                    }),
                    appearance: 'danger',
                });
            },
        });
    });
    return (<ConfirmDialog size="sm" onClose={onClose} appearance="danger" title={t({ comment: 'Withdraw esigning party dialog title', message: 'Withdraw eSigning party' })} icon={<Falcon icon="triangle-exclamation"/>} confirm={t({ comment: 'Withdraw esigning party dialog confirm button label', message: 'Withdraw' })} cancel={t({ comment: 'Withdraw esigning party dialog cancel button label', message: 'Cancel' })} onCancel={onClose} onConfirm={handleRemoveRecipient} loading={loading}>
      <Trans comment="Withdraw esigning party dialog body text">
        Are you sure you want to withdraw eSigning for <strong>{name}</strong>? They will no longer be able to access
        and sign the document.
      </Trans>
    </ConfirmDialog>);
}
